<template>
    <div class="shareWrap">
       <div class="alltool" :style="showAll ? 'height: 4.75rem;' : 'height: 2.1rem;'">

         <div class="tool"
              @click="openIndex"
              :style="showAll ? 'width: 0.75rem;height: 0.95rem;top: 0;' : 'width: 0.7rem;height: 0.7rem;top: 0;'">
           <img src="../../assets/index.png" alt="">
           <span v-if="showAll">首页</span>
         </div>
         <!--<div class="center" :style="showAll ? 'width: 0.75rem;height: 1.9rem;bottom: 0.95rem;' : 'width: 0;height: 0;bottom: 0.5rem;'">-->

         <!--</div>-->
         <div class="tool"
              @click="search"
              :style="showAll ? 'width: 0.75rem;height: 0.95rem;bottom: 2.85rem;' : 'width: 0;height: 0;bottom: 1.4rem;'">
            <img src="../../assets/search1.png" alt="">
            <span>搜索</span>
         </div>
         <div class="search-wrap"
              :style="searchIf ? '': 'width: 0rem;'">
              <input type="text" v-model="key" placeholder="疾病、姓名、专用术语"/>
              <button @click="goSearch">搜索</button>
         </div>
         <div class="tool"
              @click="goBack"
              :style="showAll ? 'width: 0.75rem;height: 0.95rem;bottom: 1.9rem;' : 'width: 0;height: 0;bottom: 1.4rem;'">
           <img src="../../assets/back.png" alt="">
           <span>返回</span>
         </div>
         
         <div class="tool"
              @click="goTop"
              :style="showAll ? 'bottom: 0.95rem;width: 0.75rem;height: 0.95rem;' : 'bottom: 0.7rem;width: 0.7rem;height: 0.7rem;'">
           <img src="../../assets/top2.png" alt="">
           <span v-if="showAll">回顶部</span>
         </div>
         <!-- <div class="tool" @click="openAll" :style="showAll ? 'bottom: 0;width: 0.75rem;height: 0.95rem;' : 'bottom: 0;width: 0.7rem;height: 0.7rem;'">
           <img src="../../assets/circle.png" alt="" :style="showAll ? 'transform: rotate(-405deg)' : 'transform: rotate(0deg)'">
         </div> -->
       </div>
       <div class="show"></div>
    </div>
</template>

<script>
  export default {
    name: "share",
    data () {
      return {
         showAll: true,
         searchIf: false,
         key: ''
      }
    },
    props: {
      type:{
        type: String,
        required: true
      }
    },
    methods: {
      goSearch() {
        if(this.key == ''){
          return;
        }
        this.$router.push({
            path:'/more/search',
            query: { key: this.key }
        });
        this.key = ''
        this.searchIf = false
      },
      search () {
        this.searchIf = !this.searchIf;
      },
      openAll () {
        if(this.showAll){
           this.searchIf = false;
        }
        this.showAll = !this.showAll
      },
      openIndex() {
        this.$router.push({
          path:'/home'
        });
      },
      goBack() {
        window.history.go(-1)
      },
      goTop(){
        var time = setInterval(function () {
          var e = document.documentElement.scrollTop || document.body.scrollTop;
          document.documentElement.scrollTop = document.body.scrollTop = e - 300;
          if (document.documentElement.scrollTop <= 0 && document.body.scrollTop <= 0) {
            document.documentElement.scrollTop = document.body.scrollTop = 0;
            clearInterval(time);
          }
        }, 10);
      }
    }
  }
</script>

<style lang="less" scoped>
  .shareWrap{
    display: block;
    position: fixed;
    z-index: 99;
    bottom: 10%;
    right: 0px;
  }
  .alltool {
    width:0.75rem;
    // overflow: hidden;
    transition: .5s;
    position: relative;
  }
  .search-wrap {
    overflow: hidden;
    font-size: 12px;
    position: absolute;
    right: 0.75rem;
    top: 0.95rem;
    height: 0.65rem;
    width: 4rem;
    transition: .2s;
    // border: 1px solid black;
    input {
      width: 75%;
      height: 100%;
      padding: 5px;
      color: #000;    
      border: 1px solid #dddddd;
      box-sizing: border-box;
      border-bottom-left-radius: 3px;
      border-top-left-radius: 3px;
    }
    button {
      color: #fff;
      width:21%;
      height: 100%;
      background-color: #3e8f83;
      border-bottom-right-radius: 3px;
      border-top-right-radius: 3px;
    }
  }
  .tool{
    position: absolute;
    right: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width:0.75rem;
    height: 0.95rem;
    background-color: rgba(255, 255, 255, .9);
    transition: all 0.3s linear;
    overflow: hidden;
    img {
      width: 0.38rem;
      height: 0.38rem;
      transition: .5s;
    }
    span {
      color: #3e8f83;
      font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/phone/share.vue